import { useEffect, useRef } from 'react';
import { IconButton, TextField, SearchIcon, CloseIcon } from '@citibox-panel/ui';

export interface CoincidencesHeaderProps {
  query: string;
  onQueryChange: (q: string) => void;
}

// Step 1's header — the search field, and nothing else. It lives in the dialog's TITLE slot rather
// than at the top of the body: the design rules it off from the results edge to edge, and a rule
// drawn inside the body would stop at the body's padding. Split from `CoincidencesStep` for that
// reason alone; the query it renders is owned by the dialog, as it was before.
export function CoincidencesHeader({ query, onQueryChange }: CoincidencesHeaderProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  // MUI moves focus only when the dialog opens, never between its steps, so nothing else can put
  // it back here on «Cambiar»; selecting after focusing is what makes a retype one keystroke. The
  // effect still runs once per visit to step 1 because the title slot holds this component only
  // while `location` is unset — returning from the filters step remounts it.
  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  return (
    // The name is deliberately not the header field's «Buscar por dirección»: two nodes under
    // one name would make an integration query ambiguous once this dialog opens over it.
    // TODO: i18n
    <TextField
      ref={inputRef}
      aria-label="Dirección del edificio"
      value={query}
      onChange={onQueryChange}
      variant="plain"
      fullWidth
      startAdornment={<SearchIcon />}
      endAdornment={
        // TODO: i18n
        <IconButton
          aria-label="Borrar búsqueda"
          onClick={() => {
            onQueryChange('');
          }}
        >
          <CloseIcon />
        </IconButton>
      }
    />
  );
}
